import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";

const CustomCellEditor = forwardRef((props, ref) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState(props.value || "");
  const [error, setError] = useState("");

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 0);
  }, []);

  useImperativeHandle(ref, () => ({
    getValue: () => value
  }));

  const isAlphaNumeric = (char) => true;

  const onKeyDown = (e) => {
    const key = e.key;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

    const isControl = e.ctrlKey || e.metaKey;

    if (!isAlphaNumeric(key) && !allowedKeys.includes(key) && !isControl) {
      e.preventDefault();
    }

    if (
      value.length >= 30 &&
      isAlphaNumeric(key) &&
      !allowedKeys.includes(key) &&
      !isControl
    ) {
      e.preventDefault();
    }
  };

  const onChange = (e) => {
    const newValue = e.target.value;
    if (newValue.length <= 30) {
      setValue(newValue);
      setError("");
    }
  };

  const onPaste = (e) => {
    const pasted = e.clipboardData.getData("text");
    //const cleaned = pasted.replace(/[^a-zA-Z0-9 ]/g, "");

    if (pasted.length + value.length > 30) {
      e.preventDefault();
      setError("Max 30 characters allowed");
      setTimeout(() => setError(""), 2000); // Clear after 2 seconds
    } else {
      // allow paste of valid alphanumeric text
      setValue((prev) => (prev + pasted).slice(0, 30));
      e.preventDefault();
    }
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <input
        type="text"
        ref={inputRef}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        onBlur={() => props.stopEditing()}
        className="ag-input-field-input ag-text-field-input"
        style={{ width: "100%", height: "100%" }}
      />
      {error && (
        <div
          style={{
            position: "absolute",
            bottom: "-1.2rem",
            left: 0,
            color: "red",
            fontSize: "0.75rem",
            backgroundColor: "#fff",
            padding: "2px 4px",
            borderRadius: "4px",
            zIndex: 10
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
});

export default CustomCellEditor;
